export const conditionType = {
  assignment: "Assignment",
  assignmentType: "AssignmentType",
  badge: "Badge",
  learningObjective: "LearningObjective",
  course: "Course",
  gradeSchemeElement: "GradeSchemeElement",
};

export const analyticsPages = {
  students: "studentPage",
  assignments: "assignmentPage",
  assignmentTypes: "assignmentTypePage",
};

export const JOB_TYPES = {
  canvasGradeImport: "canvas_grade_import",
  canvasUserImport: "canvas_user_import",
};

export const JOB_TYPE_DISPLAY_NAMES = {
  [JOB_TYPES.canvasGradeImport]: "Canvas grades import",
  [JOB_TYPES.canvasUserImport]: "Canvas user import",
  formError: "Form Error",
};

export const JOB_STATUS_TYPES = {
  pending: "pending",
  completed: "completed",
  cancelled: "cancelled",
  failed: "failed",
};

export const NOTIFICATION_JOB_STATUS_MAP = {
  completed: "success",
  pending: "warning",
  failed: "error",
  cancelled: "error",
};

export const NOTIFICATION_JOB_TASK_TYPE_MAP = {
  [JOB_TYPES.canvasGradeImport]: "background_job",
  [JOB_TYPES.canvasUserImport]: "background_job",
};

export const NOTIICATION_JOB_TASK_TYPE_DISPLAY = {
  background_job: "Background Job",
};

export const NOTIFICATION_TYPES = {
  banner: "banner",
  toast: "toast",
};

export const NOTIFICATION_STATUS_TYPES = {
  success: "success", // green
  warning: "warning", // yellow
  error: "error", // red
};

export const NOTIFICATION_VISIBILITY_TYPES = {
  hidden: "hidden",
  visible: "visible",
};

export const LEARNING_OBJECTIVE_FLAGGED_VALUE_TYPES = {
  exceedsProficiency: "exceeds_proficiency",
  proficient: "proficient",
  nearingProficiency: "nearing_proficiency",
  notProficient: "not_proficient",
};
export const LEARNING_OBJECTIVE_LEVEL_FLAGGED_VALUE_TYPES = {
  [LEARNING_OBJECTIVE_FLAGGED_VALUE_TYPES.exceedsProficiency]:
    "Exceeds Proficiency",
  [LEARNING_OBJECTIVE_FLAGGED_VALUE_TYPES.proficient]: "Proficient",
  [LEARNING_OBJECTIVE_FLAGGED_VALUE_TYPES.nearingProficiency]:
    "Nearing Proficiency",
  [LEARNING_OBJECTIVE_FLAGGED_VALUE_TYPES.notProficient]: "Not Proficient",
};

export const SCORE_LEVEL = "Score Levels";
export const RUBRIC = "Rubric";

export const COLOR_BLUE_3 = "#2E70BE";
export const COLOR_BLUE_MEDIUM_2 = "#215089";
export const COLOR_WHITE = "#fff";
export const COLOR_BLUE_RGB = "31, 119, 180";

export const GRADE_SCOPE_INDIVIDUAL = "Individual";
export const GRADE_SCOPE_GROUP = "Group";
export const GRADE_SCOPE_OPTIONS = [GRADE_SCOPE_INDIVIDUAL, GRADE_SCOPE_GROUP];

import { ckEditorAPIURLs } from "@/courses/urls.js";
import {
  apiClient,
  formRequestHeader,
} from "@/courses/services/GenericService.js";

export const editorConfigSimpleUpload = {
  simpleUpload: {
    uploadUrl: ckEditorAPIURLs.upload,
    headers: formRequestHeader,
    withCredentials: true,
  },
  image: {
    insert: {
      type: "inline",
    },
  },
  imageRemoveEvent: {
    additionalElementTypes: ["imageInline"],
    callback: (imagesSrc) => {
      var viewImageURL = ckEditorAPIURLs.view;
      if (!Array.isArray(imagesSrc) || !imagesSrc[0]) {
        // Optional: you can log, throw, or just return
        console.warn("No image src found for deletion");
        return;
      }
      var imageKey = imagesSrc[0].replace(viewImageURL, "");
      apiClient.post(ckEditorAPIURLs.delete, { name: imageKey });
    },
  },
};
export const editorConfigMediaEmbed = {
  mediaEmbed: {
    extraProviders: [
      {
        name: "kaltura",
        // Regular expression for matching kaltura.com URLs
        url: /^(https?:\/\/)?([a-z0-9-]+\.)*[a-z0-9-]+\.kaltura.com(\/.*)?$/i,
        html: (match) => {
          const url = match[0];

          return (
            '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
            '<iframe src="' +
            url +
            '" frameborder="0" allowfullscreen' +
            ' style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;">' +
            "</iframe>" +
            "</div>"
          );
        },
      },
    ],
  },
};
export const defaultEditorConfig = {
  ...editorConfigSimpleUpload,
  ...editorConfigMediaEmbed,
};

export const ENVIRONMENT_TERMS = {
  development: {
    name: "Local",
    assistantTerm: "teaching elves",
  },
  staging: {
    name: "Staging",
    assistantTerm: "sous-chefs",
  },
  production: {
    name: "Umich",
    assistantTerm: "GSIs",
  },
  beta: {
    name: "App",
    assistantTerm: "teaching assistants",
  },
};
